import { type StateCreator } from 'zustand';

export type NodeInspectorVisibleSlice = {
  nodeInspectorVisible: boolean;
  setNodeInspectorVisible: (nodeInspectorVisible: boolean) => void;
  toggleNodeInspectorVisible: () => void;
};

type CreateNodeInspectorVisibleSlice = (
  initialState: Pick<NodeInspectorVisibleSlice, 'nodeInspectorVisible'>,
) => StateCreator<NodeInspectorVisibleSlice, [], [], NodeInspectorVisibleSlice>;

export const createNodeInspectorVisibleSlice: CreateNodeInspectorVisibleSlice = (initialState) => (set) => ({
  nodeInspectorVisible: initialState.nodeInspectorVisible ?? false,
  setNodeInspectorVisible: (nodeInspectorVisible: boolean) => set({ nodeInspectorVisible }),
  toggleNodeInspectorVisible: () => set((state) => ({ nodeInspectorVisible: !state.nodeInspectorVisible })),
});
